"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var Plugin = /*#__PURE__*/function () {
  function Plugin() {
    _classCallCheck(this, Plugin);

    this._name = "Default Plugin";
    this._cache = [];
    this._scene = null;
    this._sharedData = null;
    this.needsSetup = true;
    this._videoId = "video";
    this.isResizing = false;
    this._canvas = null;
    this._pixi = null; // if set to true with will allow plugin to control video

    this.controlsVideo = false;
    this.videoContorls = null;
  }

  _createClass(Plugin, [{
    key: "name",
    get: function get() {
      return this._name;
    }
  }, {
    key: "pixi",
    get: function get() {
      return this._pixi;
    },
    set: function set(val) {
      this._pixi = val;
    }
  }, {
    key: "canvas",
    get: function get() {
      return this._canvas;
    },
    set: function set(val) {
      this._canvas = val;
    }
  }, {
    key: "scene",
    get: function get() {
      return this._scene;
    },
    set: function set(val) {
      this._scene = val;
    }
  }, {
    key: "sharedData",
    get: function get() {
      if (this._sharedData) {
        return this._sharedData;
      }

      return null;
    }
  }, {
    key: "requiresCanvas",
    value: function requiresCanvas() {
      return true;
    }
  }, {
    key: "sizeToVideo",
    value: function sizeToVideo() {
      return false;
    }
  }, {
    key: "dataToShare",
    value: function dataToShare() {
      return null;
    }
  }, {
    key: "setup",
    value: function setup(frame, videoInfo, pixi) {
      this.needsSetup = false;
    }
  }, {
    key: "update",
    value: function update() {}
  }, {
    key: "reset",
    value: function reset() {
      if (this.scene) {
        this.needsSetup = true;
        console.log("Plugin.reset");
        this.scene.removeChildren();
      }
    }
  }, {
    key: "draw",
    value: function draw(ctx, frame, params) {}
  }, {
    key: "on",
    value: function on(event) {
      return true;
    } // this method is used to override video player state

  }, {
    key: "videoInfo",
    value: function videoInfo() {} // if controlsVideo == true this method is called, return true to do normal video thing

  }, {
    key: "videoPlay",
    value: function videoPlay() {
      return true;
    } // if controlsVideo == true this method is called, return true to do normal video thing

  }, {
    key: "videoPause",
    value: function videoPause() {
      return true;
    } // if controlsVideo == true this method is called, return true to do normal video thing

  }, {
    key: "videoSetCurrentTime",
    value: function videoSetCurrentTime() {
      return true;
    }
  }, {
    key: "rectContainsPoint",
    value: function rectContainsPoint(rect, x, y) {
      return rect.x < x && rect.max.x > x && rect.y < y && rect.max.y > y;
    }
  }, {
    key: "makeRect",
    value: function makeRect(x, y, w, h) {
      return {
        x: x,
        y: y,
        center: {
          x: x + w / 2,
          y: y + h / 2
        },
        max: {
          x: x + w,
          y: y + h
        },
        w: w,
        h: h
      };
    }
  }, {
    key: "distance",
    value: function distance(from, to) {
      // distance
      var xs = from.x - to.x;
      var ys = from.y - to.y;
      xs *= xs;
      ys *= ys;
      return Math.sqrt(xs + ys);
    }
  }, {
    key: "stepValue",
    value: function stepValue(from, to, step) {
      var diff = Math.abs(from - to);

      if (diff < step) {
        return to;
      }

      if (from < to) {
        return from + step;
      } else {
        return from - step;
      }
    }
  }, {
    key: "stepPoint",
    value: function stepPoint(from, to, step) {
      // angle
      var angle = Math.atan2(to.y - from.y, to.x - from.x); // distance

      var dist = this.distance(from, to);

      if (dist < step) {
        return to;
      }

      var x = Math.cos(angle) * step + from.x;
      var y = Math.sin(angle) * step + from.y;
      return {
        x: x,
        y: y
      };
    }
  }, {
    key: "videoId",
    get: function get() {
      return this._videoId;
    },
    set: function set(val) {
      this._videoId = val;
    }
  }, {
    key: "videoReady",
    get: function get() {
      var query = "#".concat(this.videoId, " .video-container video");
      var videos = document.querySelectorAll(query);
      var ready = false;

      var _iterator = _createForOfIteratorHelper(videos),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var video = _step.value;

          if (video && video.videoWidth) {
            ready = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return ready;
    }
  }, {
    key: "videoElement",
    get: function get() {
      var cf = this.containerFrame;
      var query = "#".concat(this.videoId, " .video-container video.main-video[data-active=true]");
      var videos = document.querySelectorAll(query);

      var _iterator2 = _createForOfIteratorHelper(videos),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var video = _step2.value;

          if (video && video.dataset["active"] === "true") {
            return video;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return null;
    }
  }, {
    key: "videoFrame",
    get: function get() {
      if (this.sizeToVideo()) {
        var x = 0;
        var y = 0;
        var w = this.canvas.offsetWidth;
        var h = this.canvas.offsetHeight;
        return this.makeRect(x, y, w, h);
      } else {
        var cf = this.containerFrame;
        var video = this.videoElement;
        var _w = cf.w;
        var _h = cf.h;
        var _x = 0;
        var _y = 0;

        if (video && video.videoWidth) {
          _w = cf.w;
          _h = _w * (video.videoHeight / video.videoWidth);

          if (_h > cf.h) {
            _h = cf.h;
            _w = _h * (video.videoWidth / video.videoHeight);
          }

          _x = (cf.w - _w) / 2;
          _y = (cf.h - _h) / 2;
        } else {
          _w = cf.w;
          _h = _w * (9 / 16);
          _x = (cf.w - _w) / 2;
          _y = (cf.h - _h) / 2;
        }

        return this.makeRect(_x, _y, _w, _h);
      }
    }
  }, {
    key: "containerFrame",
    get: function get() {
      var element = this.containerElement;
      var w = window.innerWidth;
      var h = w * (9 / 16);
      var x = 0;
      var y = 0;

      if (element) {
        w = element.offsetWidth;
        h = element.offsetHeight;
        x = element.offsetLeft;
        y = element.offsetTop;
      }

      return this.makeRect(x, y, w, h);
    }
  }, {
    key: "containerElement",
    get: function get() {
      var query = "#".concat(this.videoId, " .video-player-container");
      var element = document.querySelector(query);
      return element;
    }
  }, {
    key: "safeVideoArea",
    get: function get() {
      var vf = this.videoFrame;
      var cf = this.containerFrame;
      var video = this.videoElement;
      var safeFrame = cf;
      safeFrame.s = 1;

      if (video) {
        var vvbr = video.getBoundingClientRect();
        var cr = this.containerElement.getBoundingClientRect();
        var vbr = {
          x: vvbr.x,
          y: vvbr.y,
          w: vvbr.width,
          h: vvbr.height
        };

        if (this.sizeToVideo()) {
          var scale = vbr.w / video.offsetWidth;
          var iscale = video.offsetWidth / vbr.w;
          var x = vbr.x - cr.x;
          var y = (vbr.y - cr.y) * iscale;
          var w = vbr.w;
          var h = vbr.h * iscale;

          if (w > cf.w) {
            var nw = cf.w * iscale;
            x += (w - nw) / 2;
            w = nw;
          }

          safeFrame.x = x;
          safeFrame.y = y;
          safeFrame.w = w;
          safeFrame.h = h;
          safeFrame.s = scale;
        } else {
          var _w2 = cr.width;

          if (vbr.w < cr.width) {
            _w2 = vbr.w;
          }

          var _h2 = cr.height;

          if (vbr.h < cr.height) {
            _h2 = vbr.h;
          }

          var _x2 = (cr.width - _w2) / 2;

          var _y2 = (cr.height - _h2) / 2;

          safeFrame.x = _x2;
          safeFrame.y = _y2;
          safeFrame.w = _w2;
          safeFrame.h = _h2;
        }
      }

      return safeFrame;
    }
  }, {
    key: "windowFrame",
    get: function get() {
      var w = window.innerWidth;
      var h = window.innerHeight;
      var x = 0;
      var y = 0;
      return this.makeRect(x, y, w, h);
    }
  }, {
    key: "pointAtAngle",
    value: function pointAtAngle(from, angle, distance) {
      return {
        x: Math.round(Math.cos(angle * Math.PI / 180) * distance + from.x),
        y: Math.round(Math.sin(angle * Math.PI / 180) * distance + from.y)
      };
    }
  }]);

  return Plugin;
}();

exports.default = Plugin;